import React from 'react'
import classNames from 'classnames'
import { Button } from '@/components/common'

export interface Props {
  url: string
  text?: string
  variant?: 'filled' | 'hollow'
  className?: string
}

const ApplyButton: React.FC<Props> = ({
  url,
  text = 'Apply to Fund',
  variant = 'filled',
  className,
}) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={classNames(
        { 'inline-block w-full sm:w-auto': true },
        className
      )}
    >
      <Button
        variant={variant === 'filled' ? 'primary' : 'secondary'}
        color={variant === 'filled' ? 'oxide' : 'white'}
        className=" w-full sm:w-auto"
      >
        {text}
      </Button>
    </a>
  )
}

export default ApplyButton
